import { DirectoryListItem } from 'Components/DirectoryPanel/DirectoryListItem';
import { ContentArea } from 'Components/shared/ContentArea';
import { FilterBox } from 'Components/shared/FilterBox';
import { InfoMessageBanner } from 'Components/shared/InfoMessageBanner';
import { debounce } from 'lodash';
import { MobXProviderContext, observer } from 'mobx-react';
import { SearchResult } from 'Models/SearchResult';
import * as React from 'react';
import type { RootStoreProps } from 'Stores/RootStore.types';
import { SearchableContactModelV2 } from 'Stores/SearchStore.types';
import { bugsnagClient } from 'Utils/logUtils';
import { Styled } from './index.styles';

export const Directory: React.FC = observer(() => {
  const {
    search: { getDirectorySearch, getNextDirectory, directoryMap },
    ui: { loadAllPeoplesPresence },
  } = React.useContext<RootStoreProps>(MobXProviderContext);

  const testid = 'directory';
  const directory = directoryMap.DIRECTORY;

  React.useEffect(() => {
    const loadContacts = async () => {
      await getDirectorySearch('DIRECTORY');
    };

    loadContacts().catch((err) =>
      bugsnagClient.notify(err, (event) => {
        event.severity = 'error';
        event.context = 'Directory';
        event.addMetadata('custom', {
          function: 'loadContacts',
        });
      })
    );
  }, [getDirectorySearch, loadAllPeoplesPresence]);

  const filter = debounce(async (q: string) => {
    await getDirectorySearch('DIRECTORY', q);
  }, 500);

  const handleLoadMoreContacts = debounce(async () => {
    await getNextDirectory('DIRECTORY');
  }, 500);

  return (
    <ContentArea>
      <FilterBox
        placeholder="Search Directory"
        sendInput={filter}
        loading={directoryMap.DIRECTORY.loading}
        testid={`${testid}-filterBoxDirectory`}
      />

      <Styled.InfiniteScroll
        dataLength={directory?.data?.length ?? 0} //This is important field to render the next data
        next={handleLoadMoreContacts}
        hasMore={!!directory.next}
        loader={<React.Fragment />}
        scrollableTarget="directory-list"
      >
        <Styled.List id="directory-list">
          {directory?.data?.map(
            ({ source: contact }: SearchResult<SearchableContactModelV2>) => (
              <DirectoryListItem
                key={contact.sourceId}
                contact={contact}
                {...{ testid }}
              />
            )
          )}
          <InfoMessageBanner
            testid={`${testid}-bannerInfoNoResultsFound`}
            show={
              directory?.query && (!directory?.data || !directory.data.length)
            }
            content={`No results found for "${directory?.query}"`}
          />
        </Styled.List>
      </Styled.InfiniteScroll>
    </ContentArea>
  );
});
